import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Center, Grid } from "@mantine/core";

import { CommentResponse } from "types";

import Button from '../../button/link';
import EmptyMessage from '../../empty-message';
import Loader from '../../loader';
import CommentItem from "./item";
import CommentInput from "./input";
import Text from '../../text';

interface CommentsListProps {
  comments: CommentResponse[] | undefined;
  loadingList: boolean;
  postingComment: boolean;
  onSubmit: (comment: string) => void;
}

const CommentsList = ({ comments, loadingList, postingComment, onSubmit }: CommentsListProps) => {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState<boolean>(false)

  const rows = useMemo(() => {
    if (!comments) {
      return <></>;
    }
    let tempComments = comments;
    if (!showMore) {
      tempComments = tempComments.slice(0, 3);
    }
    return tempComments.map((el, index) => <CommentItem comment={el} index={index} t={t} border={index < comments.length - 1} />);
  }, [comments, showMore]);

  return (
    <Box>
      {!comments || loadingList ? <Loader />
      : <Grid>
          <Grid.Col span={7}>
          <Text p={6} mb={'sm'} bg={'var(--mantine-color-violet-0'} fw={500}>{t('comments.list.last')}</Text>
          <Box px={'sm'}>
            {comments.length === 0 ? <EmptyMessage message={t('comments.list.empty')} />
            : rows}
            {!showMore && comments.length > 3 &&
              <Center>
                <Button
                  size={'sm'}
                  onClick={() => setShowMore(true)}
                >
                  {t('comments.more')}
                </Button>
              </Center>
            }
          </Box>
          </Grid.Col>
          <Grid.Col span={5} mah={400}>
            <Text p={6} mb={'sm'} bg={'var(--mantine-color-blue-0'} fw={500}>{t('comments.new')}</Text>
            <CommentInput onSubmit={onSubmit} loading={postingComment} t={t} />
          </Grid.Col>
        </Grid>
      }
    </Box>
  )
}


export default CommentsList;